import { DayOfWeek } from '@weareopenr/types';
import { IMenuSchedule, IPriceSchemeSchedule, ITimetableDetail, ITimetableSchedule } from 'src/api/getTimetable';
import type { IMenu } from 'src/types/menu.types';
import type { ITimetableDaySchedule } from './groupSchedulesByDay';

export type { IMenuSchedule, IPriceSchemeSchedule };

export const DAY_OF_WEEK_ORDER = Object.values(DayOfWeek);

export const isMenuSchedule = (schedule: ITimetableSchedule): schedule is IMenuSchedule => schedule.menu_id !== null;

export const isPriceSchemeSchedule = (schedule: ITimetableSchedule): schedule is IPriceSchemeSchedule =>
  schedule.price_scheme_id !== null;

export type TimetableEntityType = 'menu' | 'priceScheme';

export const getEntityType = (schedule: ITimetableSchedule): TimetableEntityType =>
  isMenuSchedule(schedule) ? 'menu' : 'priceScheme';

export const getEntityId = (schedule: ITimetableSchedule): string =>
  isMenuSchedule(schedule) ? schedule.menu_id : schedule.price_scheme_id;

export const isDefaultSchedule = (schedule: ITimetableSchedule, timetable: ITimetableDetail): boolean =>
  isMenuSchedule(schedule)
    ? schedule.menu_id === timetable.default_menu_id
    : schedule.price_scheme_id === timetable.default_price_scheme_id;

// `fr` tracks split the space left after gaps are subtracted - unlike `%`, which ignores gaps.
export const toGridTemplateColumns = (items: ITimetableDaySchedule[]): string =>
  items.map((item) => `minmax(0, ${item.dayPercent}fr)`).join(' ');

// A timetable with no ranges of its own applies to the whole brand, so every menu is in scope.
export const filterMenusByRanges = (menus: IMenu[], timetableRanges: ITimetableDetail['ranges']): IMenu[] => {
  if (timetableRanges.length === 0) return menus;
  const timetableRangeIds = new Set(timetableRanges.map((range) => range.range_id));
  return menus.filter((menu) => menu.ranges.some((range) => timetableRangeIds.has(range.range_id)));
};
